import { Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent } from '@ionic/angular/standalone';
import { ChatModalComponent } from 'src/app/components/chat-modal/chat-modal.component';
import { MoodleQuizComponent } from 'src/app/components/moodle-quiz/moodle-quiz.component';
import { EnrolledCourse, Quiz } from 'src/app/models/moodle';
import { MoodleWebService } from 'src/app/services/moodle-web.service';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-evaluation',
  templateUrl: './evaluation.page.html',
  styleUrls: ['./evaluation.page.scss'],
  standalone: true,
  imports: [IonContent, CommonModule, FormsModule, ChatModalComponent, MoodleQuizComponent]
})
export class EvaluationPage implements OnInit, OnDestroy {
  colorArray: string[] = [
    "var(--iacdp-blue-3)",
    "var(--iacdp-green-3)",
    "var(--iacdp-yellow-3)",
    "var(--iacdp-purple-3)"
  ]
  randColor: string = this.colorArray[Math.floor(Math.random() * this.colorArray.length)];
  private quizId: WritableSignal<number> = signal(4);
  public quizzes: WritableSignal<Array<Quiz>> = signal([]);
  private destroy$ = new Subject<void>();

  constructor(
    private moodleWebService: MoodleWebService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.url.subscribe(params => {
      if (this.router.getCurrentNavigation()?.extras.state) {
        this.quizId.set(this.router.getCurrentNavigation()?.extras.state?.['quizId']);
      }      
    });

    this.moodleWebService.allQuiz$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const quizzes = this.moodleWebService.getAutoEvalQuiz();
        this.quizzes.set(quizzes);   
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
